export const USER_TYPE = {
  REGULAR: 0,
  BANK: 3,
  API: 5,
};
